<template>
  <a-entity id="picture" position="0 1.5 -2">
    <a-image
      :src="leftEye"
      stereo="eye:left"
      :width="width"
      :height="height"
    ></a-image>

    <a-image
      :src="rightEye"
      stereo="eye:right"
      :width="width"
      :height="height"
    ></a-image>
    <VrFrame :width="width" :height="height"></VrFrame>
  </a-entity>
</template>

<script>
import VrFrame from "@/components/VrFrame.vue";

export default {
  components: {
    VrFrame,
  },
  data: function () {
    return { height: 2, info: null };
  },
  props: {
    img: {
      type: String,
    },
    lcoords: {
      type: String,
    },
    rcoords: {
      type: String,
    },
  },
  computed: {
    ratio: function () {
      let c = this.lcoords.split(",");
      return c[2] / c[3];
    },
    width: function () {
      return this.height * this.ratio;
    },
    leftEye: function () {
      return `${this.img}/${this.lcoords}/1024,/0/default.jpg`;
    },
    rightEye: function () {
      return `${this.img}/${this.rcoords}/1024,/0/default.jpg`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
